<form [formGroup]="siteComplianceCheckFormGroup" class="profile-form">
  <div fxLayout="row">
    <div fxLayout="column" fxLayoutAlign="center" fxFlex="1 2 auto">
      <div class="color-city-neutral font-size-small-text-bold">
        {{ "site_compliance_lbl_name" | translate }}
      </div>
      <div class="color-dark-blue font-size-body-text display-label-detail">
        {{ fullname }}
      </div>
      <div class="color-city-neutral font-size-small-text-bold">
        {{ "userprofile_phone" | translate }}
      </div>
      <div class="color-dark-blue font-size-body-text display-label-detail">
        {{ phoneNumber }}
      </div>
    </div>
    <div fxLayoutAlign="end start" fxFlex="1 2 auto">
      @if (profileImgLink) {
      <img
        src="{{ profileImgLink }}"
        (error)="profileImgLink = ''"
        class="profile-image"
      />
      } @if (!profileImgLink) {
      <mat-icon class="profile-image-empty-icon">account_circle</mat-icon>
      }
    </div>
  </div>
  <div class="divider"></div>
  <div fxLayout="column">
    @if (rapidGlobalInfoList.length > 1) {
    <div>
      <mat-form-field appearance="fill" fxFlex="100">
        <mat-label class="color-city-blue font-size-small-text-bold">{{
          "site_compliance_lbl_company" | translate
        }}</mat-label>
        <mat-select
          class="color-dark-blue font-size-body-text display-label-detail"
          [(value)]="selectedRapidGlobalId"
          (selectionChange)="selectCompany($event.value)"
          [disabled]="rapidGlobalInfoList.length <= 1"
        >
          @for (rapidGlobalInfo of rapidGlobalInfoList; track rapidGlobalInfo) {
          <mat-option [value]="rapidGlobalInfo.id">
            @if (currentUser?.withJob === true) {
            <div>
              @if (rapidGlobalInfo.jobCount > 0) {
              <div>
                {{ rapidGlobalInfo.companyName }}
                {{
                  ("site_compliance_lbl_company_job_count" | translate).replace(
                    "{job_count}",
                    rapidGlobalInfo.jobCount
                  )
                }}
              </div>
              } @if (rapidGlobalInfo.jobCount === 0) {
              <div>
                {{ rapidGlobalInfo.companyName }}
                {{ "site_compliance_lbl_company_no_job" | translate }}
              </div>
              }
            </div>
            } @if (currentUser?.withJob === false) {
            <div>
              {{ rapidGlobalInfo.companyName }}
            </div>
            }
          </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    } @if (rapidGlobalInfoList.length <= 1) {
    <div appearance="fill" fxFlex="100">
      <div class="color-city-neutral font-size-small-text-bold">
        {{ "site_compliance_lbl_company" | translate }}
      </div>
      <div class="color-dark-blue font-size-body-text display-label-detail">
        @if (rapidGlobalInfoList.length < 1) {
        <div>
          {{ defaultCompanyName }}
        </div>
        } @if (rapidGlobalInfoList.length === 1) {
        <div>
          @if (currentUser?.withJob === true) {
          <div>
            @if (rapidGlobalInfoList[0].jobCount > 0) {
            <div>
              {{ rapidGlobalInfoList[0].companyName }}
              {{
                ("site_compliance_lbl_company_job_count" | translate).replace(
                  "{job_count}",
                  rapidGlobalInfoList[0].jobCount
                )
              }}
            </div>
            } @if (rapidGlobalInfoList[0].jobCount === 0) {
            <div>
              {{ rapidGlobalInfoList[0].companyName }}
              {{ "site_compliance_lbl_company_no_job" | translate }}
            </div>
            }
          </div>
          } @if (currentUser?.withJob === false) {
          <div>
            {{ rapidGlobalInfoList[0].companyName }}
          </div>
          }
        </div>
        }
      </div>
    </div>
    }
  </div>
  <mat-divider></mat-divider>

  <div class="divider"></div>
  @if (visitorCardAvailable) {
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="100%">
      <div fxLayout="row">
        <div class="induction-button-display induction-card-container">
          @if (
            selectedSiteInductionInfo?.inductionId === null ||
            selectedSiteInductionInfo?.inductionId === undefined
          ) {
          <div fxLayout="row" fxFlex="100">
            <div fxLayoutAlign="start center" class="induction-button-img">
              <img class="site-image" [src]="currentSite?.brand?.imageUrl" />
            </div>
            <div
              fxLayout="column"
              class="induction-button-msg"
              fxLayoutAlign="center center"
            >
              <div class="induction-status induction-no-id-message">
                {{ "site_compliance_induction_add_id" | translate }}
              </div>
            </div>
            <div
              class="induction-button-icon induction-button-icon-actions"
              fxLayoutAlign="end center"
            >
              <button
                type="button"
                class="induction-update-action"
                (click)="addOrEditInduction()"
              >
                <div
                  class="induction-status-indicator"
                  fxLayout="column"
                  fxLayoutAlign="center center"
                >
                  <mat-icon class="color-city-blue">add_circle_outline</mat-icon>
                </div>
              </button>
            </div>
          </div>
          } @if (
            selectedSiteInductionInfo?.status === SiteInductionStatus.EXPIRED ||
            selectedSiteInductionInfo?.status === SiteInductionStatus.NON_COMPLIANCE
          ) {
          <div fxLayout="row" fxFlex="100">
            <div fxLayoutAlign="start center" class="induction-button-img">
              <img class="site-image" [src]="currentSite?.brand?.imageUrl" />
            </div>
            <div
              fxLayout="column"
              class="induction-button-msg"
              fxLayoutAlign="center center"
            >
              <div class="induction-status">
                {{
                  ("site_compliance_lbl_induction_no" | translate).replace(
                    "{induction_no}",
                    selectedSiteInductionInfo?.inductionId
                  )
                }}
              </div>
            </div>
            <div
              class="induction-button-icon induction-button-icon-actions"
              fxLayout="row"
              fxLayoutAlign="end center"
            >
              <div
                class="induction-status-indicator"
                fxLayout="column"
                fxLayoutAlign="center center"
              >
                <mat-icon class="color-city-red">cancel</mat-icon>
                @if (selectedSiteInductionInfo?.status === SiteInductionStatus.EXPIRED) {
                <span class="color-city-red induction-action-label">{{
                  "userprofile_siteinduction_expired" | translate
                }}</span>
                } @else {
                <span class="color-city-red induction-action-label">{{
                  "site_compliance_induction_invalid" | translate
                }}</span>
                }
              </div>
              <button
                type="button"
                class="induction-update-action"
                (click)="addOrEditInduction()"
              >
                <div
                  class="induction-status-indicator"
                  fxLayout="column"
                  fxLayoutAlign="center center"
                >
                  <mat-icon class="color-city-blue">add_circle_outline</mat-icon>
                  <span class="color-city-blue induction-action-label">{{
                    "site_compliance_induction_update" | translate
                  }}</span>
                </div>
              </button>
            </div>
          </div>
          } @if (selectedSiteInductionInfo?.status === SiteInductionStatus.COMPLIANCE) {
          <div fxLayout="row" fxFlex="100">
            <div fxLayoutAlign="start center" class="induction-button-img">
              <img class="site-image" [src]="currentSite?.brand?.imageUrl" />
            </div>
            <div
              fxLayout="column"
              class="induction-button-msg"
              fxLayoutAlign="center center"
            >
              <div class="induction-status">
                {{
                  ("site_compliance_lbl_induction_no" | translate).replace(
                    "{induction_no}",
                    selectedSiteInductionInfo?.inductionId
                  )
                }}
              </div>
            </div>
            <div class="induction-button-icon" fxLayoutAlign="end center">
              <mat-icon class="color-city-green">check_circle</mat-icon>
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
  }

  <div class="divider"></div>
  @if (profileRapidGlobalRequired) {
  <div fxLayout="row">
    <div fxLayout="column" fxFlex="100%">
      <div fxLayout="row">
        <button
          mat-stroked-button
          color="basic"
          disabled
          class="compliance-button-display"
        >
          <div fxLayout="row" fxFlex="100">
            <div fxLayoutAlign="start center" class="compliance-button-img">
              <img class="site-image" src="/assets/RapidGlobalLogo.png" />
            </div>
            <div
              fxLayout="column"
              class="compliance-button-msg"
              [fxLayoutAlign]="
                complianceErrorMessage ? 'center start' : 'center center'
              "
            >
              @if (selectedRapidGlobalInfo?.status) {
              <div class="compliance-status">
                {{ selectedRapidGlobalInfo?.status }}
              </div>
              } @if (checkIfComplianceShouldDisplayNotEnable()) {
              <div class="compliance-status">{{ statusNotApplicable }}</div>
              } @if (defaultCompanyName == this.defaultCityFMCompanyName ||
              defaultCompanyName == this.defaultCityFMAsiaCompanyName) {
              <div class="compliance-status">{{ this.statusCompliant }}</div>
              } @if (complianceErrorMessage) {
              <div
                class="compliance-message"
                style="
                  width: inherit;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  text-align: left;
                "
              >
                {{ complianceErrorMessage }}
              </div>
              }
            </div>
            <div class="compliance-button-icon" fxLayoutAlign="end center">
              @if (selectedRapidGlobalInfo?.status === statusCompliant ||
              defaultCompanyName == defaultCityFMCompanyName ||
              defaultCompanyName == defaultCityFMAsiaCompanyName) {
              <mat-icon class="color-city-green">task_alt</mat-icon>
              } @if (selectedRapidGlobalInfo?.status === statusNotCompliant) {
              <mat-icon class="color-city-red">error</mat-icon>
              } @if (selectedRapidGlobalInfo?.status === statusNotApplicable ||
              checkIfComplianceShouldDisplayNotEnable()) {
              <div class="na-icon">
                {{ notComplianceIcon }}
              </div>
              }
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
  }
</form>
